export const getPostLicenseRequest = (customerId, payload) => {
  return {
    url: `/api/License?customerId=${customerId}`,
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload),
  };
};
export const getPutLicenseRequest = (payload) => {
  return {
    url: `/api/License`,
    method: "PUT",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(payload),
  };
};
export const getDeleteLicenseRequest = (licenseId) => {
  return {
    url: `/api/License?licenseId=${licenseId}`,
    method: "DELETE",
    headers: {
      "Content-Type": "application/json"
    },
  };
};
export const getLicenseFileGetRequest = (licenseId) => {
  return {
    url: `/api/License/get?licenseId=${licenseId}`,
    responseType: "blob",
    method: "GET",
    headers: {
      "Content-Type": "application/xml"
    },
  };
};

export const getLicensesGetRequest = () => {
  return {
    url: "/api/License",
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    },
  };
};

export const getLicensesGetRequestForCustomer = () => {
  return {
    url: "/api/LicenseAssigment/All",
    method: "GET",
    headers: {
      "Content-Type": "application/json"
    },
  };
};

